import React from 'react';
import ReactDOM from "react-dom";
import {LocationCoordinates} from "@wix/devzai-utils-common";
import {GoogleMapElement} from "./google-map-element";

export interface GoogleMapEmbeddedBootstrapOptions {
    locationCoordinates: LocationCoordinates;
    zoom: number;
    languageCode: string;
    googleMapsApiKey: string;
    disableMapInteractions: boolean;
    onMapReady?: () => void;
    isDarkMode?: boolean;
}

export function googleMapEmbeddedBootstrap(
    contentWindow: Window & {updateMapProps?: (mapProps: Partial<GoogleMapEmbeddedBootstrapOptions>) => void},
    options: GoogleMapEmbeddedBootstrapOptions
): () => void {
    const rootDiv = contentWindow.document.createElement('div');
    contentWindow.document.body.appendChild(rootDiv);

    const renderMap = (renderProps: Partial<GoogleMapEmbeddedBootstrapOptions> = {}) => {
        const googleMapContent = (
            <GoogleMapElement
                {...options}
                {...renderProps}
                contentWindow={contentWindow}
            />
        );

        // eslint-disable-next-line react/no-deprecated
        ReactDOM.render(googleMapContent, rootDiv);
    };

    renderMap();

    contentWindow.updateMapProps = renderMap;

    return () => {
        // eslint-disable-next-line react/no-deprecated
        ReactDOM.unmountComponentAtNode(rootDiv);

        rootDiv.parentNode?.removeChild(rootDiv);

        delete contentWindow.updateMapProps;
    };
} 